export enum CompletionStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2
}
